import { render, staticRenderFns } from "./STableOrderComp.vue?vue&type=template&id=7e4a02a4&"
import script from "./STableOrderComp.vue?vue&type=script&lang=js&"
export * from "./STableOrderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports